import React, {Component} from 'react'
import {Spin, Form, Checkbox,Row, Select, DatePicker, Col, Card, Button} from 'antd'
import Moment from 'moment'
import {connect} from 'react-redux'
import getDate from 'util/ConfigDates'
import {fetchReportBalance, fetchReportBalanceTotal} from 'appRedux/actions/Reports'

const FormItem = Form.Item

class ReportBalance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateFrom: getDate('dateFrom'),
      dateTo: getDate('dateTo'),
      validateDate: 'error',
      helpDate: 'Este es un campo obligatorio.',
    }
  }

  componentDidMount() {
    this.props.fetchReportBalance({
      dateFrom: getDate('dateFrom'),
      dateTo: getDate('dateTo'),
    })
  }



  onHandleClick = event => {
    event.preventDefault()
    if (this.state.dateFrom !== '' && this.state.dateTo !== '') {
      console.log(this.state);
      this.props.fetchReportBalance(this.state)
    }
    if(this.state.checked){
        console.log(this.state.checked);

        this.state.dateFrom="1900-10-10";
        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        const separator='-';
        this.state.dateTo= `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date}`

        console.log('Historico', this.state);
        this.props.fetchReportBalance(this.state)
    }

  }

  onClickDateFrom = (date, dateString) => {
    this.setState({
      dateFrom: dateString,
    })
  }

  onClickDateTo = (date, dateString) => {
    this.setState({dateTo: dateString})
  }

  //Checkbox
  state = {
    disableDate: false,
    checked: true,
    disabled: false,
  };

  showHistory = e => {
    console.log('checked = ', e.target.checked);
    this.setState({
      checked: e.target.checked,
      disableDate: !this.state.disableDate
    });
  };


  render() {
    const {dateFrom, dateTo, validateDate, helpDate} = this.state
    const label = `${this.state.checked ? 'Mostrar histórico' : 'Mostrar histórico'
    }`;
    return (
      <Card>
        <Form onSubmit={this.onHandleClick}>
          <Row>
            <Col span={7}>
              <FormItem
                label="Desde :"
                validateStatus={dateFrom !== '' ? '' : validateDate}
                help={dateFrom !== '' ? '' : helpDate}
                labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
              >
                <DatePicker
                  defaultValue={Moment(dateFrom, 'YYYY-MM-DD')}
                  className="gx-mb-3 gx-w-100"
                  disabled={this.state.disableDate}
                  onChange={this.onClickDateFrom}
                />
              </FormItem>
            </Col>
            <Col span={7}>
              <FormItem
                label="Hasta : "
                validateStatus={dateTo !== '' ? '' : validateDate}
                help={dateTo !== '' ? '' : helpDate}
                labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
              >
                <DatePicker
                  defaultValue={Moment(dateTo, 'YYYY-MM-DD')}
                  className="gx-mb-3 gx-w-100"
                  disabled={this.state.disableDate}
                  onChange={this.onClickDateTo}
                />
              </FormItem>
            </Col>
            <Col span={6}>
                <Checkbox
                  onChange={this.showHistory}
                >
                  {label}
                </Checkbox>
            </Col>
            <Col span={4} className="gx-text-right">
              <Button type="primary" onClick={this.onHandleClick}>
                <i className="icon icon-search" />
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    )
  }
}

function mapStateToProps({reports}) {
  const {balanceReport} = reports
  return {
    balanceReport,
  }
}

export default connect(
  mapStateToProps,
  {fetchReportBalance},
)(ReportBalance)



// WEBPACK FOOTER //
// ./src/routes/main/Reports/balance/ReportBalance.js